import { useQuery } from "@tanstack/react-query";

import { tarefaService } from "@/services/api/tarefa.service";
import { PeriodoResumoAdminTarefas, TarefaResumoAdminPeriodoDTO } from "@/types/tarefa.type";

export function useTarefaAdminResumoPeriodo(dias: PeriodoResumoAdminTarefas) {
  const { data, isLoading } = useQuery<TarefaResumoAdminPeriodoDTO>({
    queryKey: ["tarefa-resumo-admin-periodo", dias],
    queryFn: () => tarefaService.getResumoAdminPorPeriodoTarefas(dias),
  });

  return {
    resumo: data ?? {
      criadasPorDia: [],
      concluidasPorDia: [],
      porTipo: [],
      totalComentarios: 0,
      totalDocumentos: 0,
    },
    loading: isLoading,
  };
}
